import { Component, OnInit , AfterViewChecked} from '@angular/core';
import { SessionService } from '../shared/services/session.service';
import { BackendApiService } from '../shared/services/backend-api.service';
import { MatSnackBar, MatDialog } from '@angular/material';

declare let paypal: any;


@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements AfterViewChecked  {

  addScript = false;
  paypalLoad = true;
  finalAmount = 1;
  packageData: any;
  user: any;
  constructor(
    public dialog: MatDialog,
    private sessionService: SessionService,
	  private backendApiService: BackendApiService,
    private snackBar: MatSnackBar
  ) {
    
  }
  
  paypalConfig = {
    env: 'sandbox',
    client: {
      sandbox: 'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R',
      production: '<your-production-key here>'
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            { amount: { total: this.packageData.price, currency: 'GBP' } }
          ]
        }
      });
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        // Do something when payment is successful.
        console.log(payment + data);
        this.user = this.sessionService.getData();
        const  requestData = {
          "userId":this.user.id,
          "deviceType":this.user.deviceId,
          "packId":this.packageData.id,
          "packOrMovieId":'1',
          "amount":this.packageData.price,
          "paymentStatus": payment.state === "approved" ? "1" : "0",
          "countryIso":this.user.countryISOCode,
           "paymentDate": payment.create_time,
           "paymentCurrency":payment.transactions[0].amount.currency,
           "paymentInVoiceId": payment.id,
           "paymentTranscationId": data.orderID,
           "paymentResponseCode": data.paymentToken,
           "paymentResult": data.intent,
           "paymentReferenceNumber": data.orderID,
           "paymentPayPageId": data.payerID,
           "payementReceipt": data.orderID,
           "gatewayId":"2"
  }
          this.backendApiService
              .postRawRequest('packageActivationRequest', requestData)
              .subscribe(
                (response: any) => {
                  if (response.isPackageActivated === 'TRUE') {
                    this.snackBar.open('Order payment is successfull', '', {
                      duration: 2000
                    });
                    setTimeout(() => {
                      location.reload();
                    }, 2000);

                  } else if (response.responseCode === 'FC101') {
                    this.snackBar.open('Something went wrong', 'close', {
                      duration: 2000
                    });
                  }else{
                    this.snackBar.open('', 'close', {
                      duration: 3000
                    });
                  }
                },
                error => {
                  this.snackBar.open(
                    new DOMParser()
                      .parseFromString(error.error, "text/html")
                      .getElementsByTagName('p')[1].textContent.replace('message',''),
                    "",
                    {
                      duration: 2000,
                      verticalPosition: "top",
                      horizontalPosition: "center",
                      direction: "ltr"
                    }
                  );
                }
              );
      });
    },
    onCancel: function(data, actions) {
      /*
       * Buyer cancelled the payment
       */
      console.log(actions + data);
    },

    onError: function(err) {
      /*
       * An error occurred during the transaction
       */
       console.log(err);
    }
  };

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
        this.paypalLoad = false;
      });
    }
  }

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:prefer-const
      let scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/payment.component.ts